// Navigation seulement : aucun jeton, code d'acces ou droit n'est transporte.
const HANDOFF_PARAMS = ["auth", "authIntent", "authTransport"];
const EVENT_INTENTS = new Set(["join_event", "reserve_event_badge"]);

export function buildAuthBrowserUrl(location, intent) {
  const current = new URL(location.href);
  const url = new URL(current.pathname, current.origin);
  ["eventId", "profile", "section", "offerId", "src", "v"].forEach((key) => {
    if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
  });
  url.searchParams.set("auth", "google");
  url.searchParams.delete("authIntent");
  url.searchParams.delete("authTransport");
  if (EVENT_INTENTS.has(intent?.type) && intent.eventId) {
    url.pathname = "/";
    url.searchParams.set("eventId", intent.eventId);
    url.searchParams.delete("section");
    url.searchParams.delete("offerId");
    url.searchParams.delete("profile");
    url.searchParams.set("authIntent", intent.type);
    if (intent.transport) url.searchParams.set("authTransport", "1");
  }
  return url.href;
}

export function readAuthBrowserHandoff(location) {
  const params = new URLSearchParams(location.search);
  if (params.get("auth") !== "google") return null;
  const type = params.get("authIntent");
  const eventId = params.get("eventId")?.trim();
  const intent = EVENT_INTENTS.has(type) && eventId
    ? { type, eventId, ...(params.get("authTransport") === "1" ? { transport: true } : {}), createdAt: Date.now() }
    : null;
  return { intent };
}

export function clearAuthBrowserHandoff(browserWindow) {
  const url = new URL(browserWindow.location.href);
  HANDOFF_PARAMS.forEach((key) => url.searchParams.delete(key));
  browserWindow.history.replaceState(browserWindow.history.state, "", url.href);
}

export function buildAndroidBrowserIntent(url) {
  const target = new URL(url);
  if (target.protocol !== "https:" && target.protocol !== "http:") return null;
  // Le geste de clic permet a Android d'ouvrir Chrome hors de la WebView.
  return `intent://${target.host}${target.pathname}${target.search}#Intent;scheme=${target.protocol.slice(0, -1)};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(target.href)};end`;
}
